module.exports = __webpack_public_path__ + "img/comp_sri.dc29efd1.png";